"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bba0 = void 0;
var abr_types_1 = require("../../abr-types");
var unexpected_codepath_1 = require("../../utils/unexpected-codepath");
var DEFAULT_RESERVOIR_SIZE = 8;
var DEFAULT_CUSHION_SIZE = 30;
var Bba0 = /** @class */ (function () {
    function Bba0(logger, bufferAssessment, bba0Config) {
        this.bufferAssessment = bufferAssessment;
        this.shouldWaitForBandwidth = false;
        this.ratePrev = 0;
        this.tracksAscending = [];
        this.logger = logger.withContext('BBA_0');
        this.logger.verbose('Received config: ', bba0Config);
        this.bba0Config = __assign({ cushionSize: DEFAULT_CUSHION_SIZE, reservoirSize: DEFAULT_RESERVOIR_SIZE }, bba0Config);
        this.logger.info('Using config: ', this.bba0Config);
    }
    Object.defineProperty(Bba0.prototype, "name", {
        get: function () {
            return abr_types_1.AbrType.BBA_0;
        },
        enumerable: false,
        configurable: true
    });
    Bba0.prototype.getRecommendedTracks = function () {
        if (!this.tracksAscending.length) {
            return null;
        }
        return this.chooseTracks();
    };
    Bba0.prototype.setTracksAscending = function (tracksAscending) {
        this.tracksAscending = tracksAscending;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Bba0.prototype.notifiedPlaybackRateChange = function (rate) {
        // No-op
    };
    Bba0.prototype.chooseTracks = function () {
        var tracksDescending = this.tracksAscending.slice().reverse();
        var _a = this.bba0Config, reservoirSize = _a.reservoirSize, cushionSize = _a.cushionSize;
        var trackMax = tracksDescending[0];
        var trackMin = this.tracksAscending[0];
        var ratePrev = Math.min(Math.max(this.ratePrev, trackMin.combinedBandwidth), trackMax.combinedBandwidth); // NB: Min is currently selected at the start by default
        var trackMinus = tracksDescending.find(function (_a) {
            var combinedBandwidth = _a.combinedBandwidth;
            return combinedBandwidth < ratePrev;
        }) || trackMin;
        var trackPlus = this.tracksAscending.find(function (_a) {
            var combinedBandwidth = _a.combinedBandwidth;
            return combinedBandwidth > ratePrev;
        }) || trackMax;
        var currentBufferLevel = this.bufferAssessment.getStabilisedBufferAhead();
        var mappedBitrate = this.getMappedBitrate(this.tracksAscending, currentBufferLevel);
        var tracksNext;
        if (currentBufferLevel <= reservoirSize) {
            tracksNext = trackMin; // Choosing lowest bitrate, as buffer is close to empty
        }
        else if (currentBufferLevel >= reservoirSize + cushionSize) {
            tracksNext = trackMax; // Choosing highest bitrate, as buffer is very full
        }
        else if (mappedBitrate >= trackPlus.combinedBandwidth) {
            // Buffer is more full than threshold for next rate up, so changing to a higher bitrate
            var switchUp = tracksDescending.find(function (_a) {
                var combinedBandwidth = _a.combinedBandwidth;
                return combinedBandwidth <= mappedBitrate;
            });
            if (switchUp) {
                tracksNext = switchUp;
            }
            else {
                (0, unexpected_codepath_1.unexpectedCodepath)('BBA-0 is always expected to find a "switch up" variant', this.logger);
                tracksNext = trackPlus;
            }
        }
        else if (mappedBitrate <= trackMinus.combinedBandwidth) {
            // Buffer is less full than threshold for next rate down, so changing to a lower bitrate
            var switchDown = this.tracksAscending.find(function (_a) {
                var combinedBandwidth = _a.combinedBandwidth;
                return combinedBandwidth > mappedBitrate;
            });
            if (switchDown) {
                tracksNext = switchDown;
            }
            else {
                (0, unexpected_codepath_1.unexpectedCodepath)('BBA-0 is always expected to find a "switch down" variant', this.logger);
                tracksNext = trackMinus;
            }
        }
        else {
            // Buffer has not crossed threshold for next lowest/highest bitrate, so staying with current track
            // If available tracks have changed since last choice and current rate isn't available, goes to the next one down
            tracksNext = tracksDescending.find(function (v) { return v.combinedBandwidth === ratePrev; }) || trackMinus;
        }
        this.ratePrev = tracksNext.combinedBandwidth;
        return tracksNext;
    };
    Bba0.prototype.getMappedBitrate = function (tracksAscending, currentBufferLevelSeconds) {
        var _a = this.bba0Config, reservoirSize = _a.reservoirSize, cushionSize = _a.cushionSize;
        var smallestBitrate = tracksAscending[0].combinedBandwidth;
        var largestBitrate = tracksAscending[tracksAscending.length - 1].combinedBandwidth;
        var ratePerSecondInBuffer = (largestBitrate - smallestBitrate) / cushionSize;
        return smallestBitrate + (currentBufferLevelSeconds - reservoirSize) * ratePerSecondInBuffer;
    };
    Bba0.prototype.destroy = function () {
        // noop
    };
    return Bba0;
}());
exports.Bba0 = Bba0;
